import React, { useState } from 'react';
import leaveService from '../../services/leaveService';
import communicationService, { COMM_EVENT_KEYS } from '../../services/communicationService';
import { useAuth } from '../../hooks/useAuth';
import toast from 'react-hot-toast';

export default function LeaveForm({ onSuccess, onCancel }) {
  const { user } = useAuth();

  const [form, setForm] = useState({
    start_date: '',
    end_date: '',
    reason: '',
  });
  const [sendEmail, setSendEmail] = useState(true);
  const [loading, setLoading] = useState(false);
  const handle = (e) => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const saved = await leaveService.apply(form);
      if (sendEmail) {
        try {
          await communicationService.dispatchEvent(COMM_EVENT_KEYS.LEAVE_APPLIED, {
            leave_id: saved?.id,
            actor_user_id: user?.id,
            context: {
              start_date: form.start_date,
              end_date: form.end_date,
            },
          });
        } catch {
          toast.error('Leave submitted, but email dispatch is not configured');
        }
      }
      toast.success('Leave applied — auto-approved');
      onSuccess();
    } catch (err) {
      toast.error('Failed to apply for leave');
    } finally { setLoading(false); }
  };

  return (
    <form onSubmit={submit}>
      <div className="grid-2">
        <div className="form-group">
          <label className="form-label">Start Date *</label>
          <input className="form-control" type="date" name="start_date" value={form.start_date} onChange={handle} required />
        </div>
        <div className="form-group">
          <label className="form-label">End Date *</label>
          <input className="form-control" type="date" name="end_date" value={form.end_date} onChange={handle} required />
        </div>
      </div>
      <div className="form-group">
        <label className="form-label">Reason</label>
        <textarea className="form-control" name="reason" value={form.reason} onChange={handle} rows={3} placeholder="Reason for leave…" />
      </div>
      <div style={{ background: 'var(--info-light)', color: 'var(--info-text)', borderRadius: 'var(--radius-md)', padding: '0.75rem 1rem', fontSize: '0.8125rem', marginBottom: '0.75rem' }}>
        Leave requests are submitted by drivers only and are not tied to a specific vehicle.
      </div>
      <div className="form-group">
        <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.875rem', color: 'var(--gray-600)' }}>
          <input
            type="checkbox"
            checked={sendEmail}
            onChange={(e) => setSendEmail(e.target.checked)}
          />
          Send leave notification email
        </label>
      </div>
      <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'flex-end' }}>
        <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancel</button>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Applying…' : 'Apply for Leave'}
        </button>
      </div>
    </form>
  );
}